export enum View {
  SuccessView = "SuccessView",
  UploadFileView = "UploadFileView",
  SelectTransactionView = "SelectTransactionView"
}
